import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import NativeSelect from '@material-ui/core/NativeSelect';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import DateFnsUtils from '@date-io/date-fns';
import Autocomplete from '@material-ui/lab/Autocomplete';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import NumberFormat from 'react-number-format';
import * as CashTeller from './Saga/CashTellers';
import jaLocale from "date-fns/locale/ja";
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { threadId } from 'worker_threads';
import format from "date-fns/format";
import { array } from 'prop-types';
import { ExportToCsv } from 'export-to-csv';

var moment = require('moment-timezone');

interface Props {
    modalcontract: any,
    toggle: any,
    cash_tellers_list: any,
    GetList: any

}

interface State {
    refresh: boolean,
    selectedDate: Date,
    selectedDate2: Date,
}

const options = {
    fieldSeparator: ',',
    quoteStrings: '',
    decimalSeparator: '.',
    useTextFile: false,
    useBom: false,
    useKeysAsHeaders: false,
};

const csvExporter = new ExportToCsv(options);


class Cashteller extends Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props);
        this.state = {
            refresh: false,
            selectedDate: new Date(),
            selectedDate2: new Date(),
        }
        this.date_change = this.date_change.bind(this);
        this.date_change2 = this.date_change2.bind(this);
        this.csv = this.csv.bind(this);

    }

    refresh() {
        this.setState(prevState => ({
            refresh: !prevState.refresh,
        }));

        console.log(this.state.refresh);

        return
    }

    date_change = (date: any) => {
        this.setState({
            selectedDate: new Date(date),
        });
    };
    date_change2 = (date: any) => {
        this.setState({
            selectedDate2: new Date(date),
        });
    };

    csv() {

        var csv: any = [];
        var i = 0;
        // created_atを見る
        this.props.cash_tellers_list[0]["CSVdata"].forEach((value: any) => {

            console.log(moment(value[0], 'YYYY-MM-DD').tz("Asia/Tokyo").format('YYYY-MM-DD'));

            if (moment(value[0], 'YYYY-MM-DD').tz("Asia/Tokyo").format('YYYY-MM-DD') >= moment(this.state.selectedDate).tz("Asia/Tokyo").format('YYYY-MM-DD')
                && moment(value[0], 'YYYY-MM-DD').tz("Asia/Tokyo").format('YYYY-MM-DD') <= moment(this.state.selectedDate2).tz("Asia/Tokyo").format('YYYY-MM-DD')) {
                var data = value;
                data.shift();
                csv[i] = data;
                i = i + 1;
            } else if (moment(value[0], 'YYYY-MM-DD').tz("Asia/Tokyo").format('YYYY-MM-DD') == moment(this.state.selectedDate).tz("Asia/Tokyo").format('YYYY-MM-DD')
                || moment(value[0], 'YYYY-MM-DD').tz("Asia/Tokyo").format('YYYY-MM-DD') == moment(this.state.selectedDate2).tz("Asia/Tokyo").format('YYYY-MM-DD')) {
                var data = value;
                data.shift();
                csv[i] = data;
                i = i + 1;
            }

        });

        console.log(csv);

        if (!csv[0]) {
            alert("データがありません");
        } else {
            csvExporter.generateCsv(csv);
        }

        this.props.GetList();
    }

    render() {

        return (
            <div>

                <Modal isOpen={this.props.modalcontract} toggle={this.props.toggle} fade={false}>
                    <ModalHeader toggle={this.props.toggle}>
                        CSVをダウンロードする
                    </ModalHeader>
                    <ModalBody style={{ fontSize: "18px" }} >

                        <div>登録日を指定</div>


                        {/* 日付選択 */}
                        <div>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={jaLocale}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    variant="inline"
                                    margin="normal"
                                    id="date-picker-dialog"
                                    format="yyyy/MM/dd"
                                    value={this.state.selectedDate}
                                    onChange={this.date_change}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>

                        <div>
                            <i style={{ fontSize: "25px", paddingLeft: "50px", marginTop: "15px" }} className="fas fa-long-arrow-alt-down"></i>
                        </div>


                        {/* 日付選択 */}
                        <div>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={jaLocale}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    variant="inline"
                                    margin="normal"
                                    id="date-picker-dialog"
                                    format="yyyy/MM/dd"
                                    value={this.state.selectedDate2}
                                    onChange={this.date_change2}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>


                        <div>
                            <button style={{ marginTop: "20px" }} className="btn btn btn-success item-outer" onClick={this.csv}>ダウンロード</button>
                        </div>



                    </ModalBody>
                    <ModalFooter>
                    </ModalFooter>
                </Modal>
            </div >
        );
    }
};


const mapStateToProps = (state: any) => {
    return {
        shops: state.masterReducer.shops,
        users: state.masterReducer.users,
        cash_tellers_list: state.CashTeller.cash_tellers_list,

    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        cash_tellers_insert(state: any) {
            dispatch(CashTeller.cash_tellers_insert(state))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Cashteller);




